/**
 * Şirket künyesi — sitenin görünen yüzündeki TEK kaynak.
 *
 * Değerler kullanıcıdan geldi (17 Eyl 2026) ve yasal metinlerin satıcı
 * tablosuyla AYNI (`packages/shared/src/legal-seed-sales.ts` → `SELLER_TR`).
 * Yasal metnin yaşayan kopyası veritabanında; künye değişirse
 * `/backstage/legal`teki satıcı tabloları da elle güncellenir — ikisi
 * ayrışırsa sözleşmedeki satıcı ile sitedeki satıcı farklı kişi olur.
 *
 * Neden çeviri dosyasında değil: unvan, adres ve numaralar çevrilmez. 11 dil
 * İngilizceden DeepL'le üretiliyor (`scripts/i18n/translate.mjs`); "Meclis
 * Mah. Derviş Sk." çeviriye girseydi bozulur, telefon ve e-posta boş kalan
 * dillerde hiç basılmazdı. Etiketler ("Unvan", "Adres") çeviride, değerler
 * burada.
 *
 * Kullananlar: footer'ın künye satırı, /contact künyesi, /about künyesi.
 * 14 Eki 2026 — iyzico üye iş yeri incelemesi şirketin sitede açıkça
 * görünmesini istiyor.
 */
export const COMPANY = {
  /** Yasal unvan — sözleşmelerde yazan biçim. */
  legalName: 'Mekjoy Dijital Bilişim Anonim Şirketi',
  /** Dar alanlar için (künye hücresi). */
  shortName: 'Mekjoy Dijital Bilişim A.Ş.',
  address: 'Meclis Mah. Derviş Sk. No: 38, Sancaktepe / İstanbul',
  taxOffice: 'Sarıgazi',
  taxNumber: '6140932362',
  email: 'info@mekjoy.com',
  /** Görünen biçim; `tel:` bağlantısı rakamları buradan süzerek kuruyor. */
  phone: '+90 850 840 79 00',
} as const;

/** `tel:` adresi — boşluksuz, `+` korunuyor. */
export const companyPhoneHref = `tel:${COMPANY.phone.replace(/[^\d+]/g, '')}`;
